import { render, staticRenderFns } from "./campaigns-tasks-list-page.vue?vue&type=template&id=e5151fb8&"
import script from "./campaigns-tasks-list-page.vue?vue&type=script&lang=js&"
export * from "./campaigns-tasks-list-page.vue?vue&type=script&lang=js&"
import style0 from "./campaigns-tasks-list-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports